import { Flex, Text, Select } from '@scale/scaleui-radix';
import type { Column } from '@scale/compass-shared/types';

interface UserIdentifierColumnSelectorProps {
  selectedColumn: string | undefined;
  availableColumns: Column[];
  onChange: (columnId: string) => void;
}

export default function UserIdentifierColumnSelector({
  selectedColumn,
  availableColumns,
  onChange,
}: UserIdentifierColumnSelectorProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="bold">
        Step 4: Select column containing user identifiers <span style={{ color: 'red' }}>*</span>
      </Text>
      <Select.Root value={selectedColumn} onValueChange={onChange}>
        <Select.Trigger placeholder="Select a column" />
        <Select.Content>
          {availableColumns.map(column => (
            <Select.Item key={column.id} value={column.id}>
              {column.header || column.id}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
